import LoginScreen from "@/modules/login";

export default function Login() {
  return <LoginScreen />;
}
